import fetchEmails from '../Services/fetchEmails'
import { clearEmails } from '../State/emails'
import { setFetching } from '../State/fetching'

let previousProjectId = null

export default (props) => async (dispatch) => {
  
  // Check if additionalFilter.project_id has changed
  const currentProjectId = props && props.additionalFilter && props.additionalFilter.project_id
  
  if (previousProjectId && currentProjectId && previousProjectId !== currentProjectId) {
    // Clear the old emails data and show loading state
    dispatch(clearEmails())
    dispatch(setFetching(true))
    
    // Fetch the new emails
    dispatch(fetchEmails())
  }
  
  // Update the previous project ID
  previousProjectId = currentProjectId
}
